export default function (state, val) {
    state.page = 1;
    state.loading = false;
    state.items = val.Statements;
}